import udfRouterPaths from './udfRouterPaths';

export default udfRouterPaths;
